export default __webpack_public_path__ + "static/media/seethru-avatar.ba6497fe.svg";